module.exports = __webpack_public_path__ + "static/img/image_jyocr04.abb05d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/solution/panels/img/education/image_jyocr04.jpg
// module id = Spue
// module chunks = 0